import { render, staticRenderFns } from "./ShopSelect.vue?vue&type=template&id=63fbc841&scoped=true&"
import script from "./ShopSelect.vue?vue&type=script&lang=js&"
export * from "./ShopSelect.vue?vue&type=script&lang=js&"
import style0 from "./ShopSelect.vue?vue&type=style&index=0&id=63fbc841&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fbc841",
  null
  
)

export default component.exports